var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCursorOpen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E3D900",
    d: "M0 0h56v56H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.101 27.102H19v1.8H27.1V37h1.8V28.9h8.098v-1.8H28.9v-8.1h-1.8v8.1z",
    fill: "#170F4F"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cmVjdCB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIGZpbGw9IiNFM0Q5MDAiIC8+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICBkPSJNMjcuMTAxMSAyNy4xMDE1TDE4Ljk5OTYgMjcuMTAxNVYyOC45MDE0TDI3LjEwMTEgMjguOTAxNEwyNy4xMDExIDM2Ljk5OTlMMjguOTAxIDM2Ljk5OTlWMjguOTAxNEgzNi45OTg2VjI3LjEwMTVIMjguOTAxTDI4LjkwMSAxOS4wMDA5TDI3LjEwMTEgMTkuMDAwOUwyNy4xMDExIDI3LjEwMTVaIgogICAgZmlsbD0iIzE3MEY0RiIgLz4KPC9zdmc+";
export { SvgCursorOpen as ReactComponent };